goog.provide("shadow.js.shim.module$date_fns$locale$pl$default");
shadow.js.shim.module$date_fns$locale$pl$default = esm_import$date_fns$locale$pl.default;
